import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-powerwashing',
  templateUrl: './powerwashing.component.html',
  styleUrls: ['./powerwashing.component.css']
})
export class PowerwashingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
